
<div class="d-flex">
	<button type="button" class="modal-close small ml-auto text-secondary" aria-label="Close" (click)="closeModal()"><fa-icon [icon]="['fas', 'times']"></fa-icon></button>
</div>

<div class="mb-2 d-block" *ngIf="currentBoard">
	
	<div class="d-flex align-items-end pr-2">
		<div class="btn btn-link text-left px-3 mr-2 btn-board text-secondary font-weight-medium" (click)="onSelectBoard()">
			<div>
				<div class="text-small">Add to</div>
				<div class=" text-truncate">{{currentBoard.name}} Travel Board</div>
			</div>
			<!-- <div *ngIf="!currentBoard">
				<div class="text-small">Select a</div>
				<div class=" text-truncate">Travel Board</div>
			</div> -->
		</div>
		<fa-icon [icon]="['fas', 'chevron-down']" class="ml-auto text-secondary pb-2 clickable" (click)="onChooseBoard()"></fa-icon>
	</div>

</div>

<hr class="my-2" *ngIf="currentBoard" />

<div class="btn btn-link px-3 mb-2 d-block text-left text-secondary font-weight-medium" (click)="onCreateBoard()">Create New Travel Board</div>

<!-- <div class="text-small text-danger">productId: {{productId}}</div> -->
